<template>
  <div>
    <v-dialog v-model="value" scrollable persistent max-width="700px">
      <v-card>
        <v-card-title>
          <v-spacer /><v-btn icon @click="$emit('input', false)"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <Pagination
            :key="'top_pagination_' + timestamp"
            v-model="page"
            :limit="limit"
            :total="total"
            @onChange="onChange($event)"
          ></Pagination>
          <v-data-table
            :headers="headers"
            :pagination.sync="pagination"
            :items="data"
            class="elevation-1"
            hide-actions
            :loading="loading"
          >
            <template #items="props">
              <tr>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.product_name }}</td>
                <td>{{ props.item.announcement_message }}</td>
                <td>{{ props.item.timestamp | DateFormat('DD/MM/YYYY เวลา HH:mm น.') }}</td>
              </tr>
            </template>
          </v-data-table>

          <Pagination
            :key="'bottom_pagination_' + timestamp"
            v-model="page"
            :limit="limit"
            :total="total"
            @onChange="onChange($event)"
          ></Pagination>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Pagination from '@/components/elements/Pagination.vue'
import api from '@/api'
import { mapGetters } from 'vuex'
import moment from 'moment'
export default {
  components: {
    Pagination
  },
  props: ['value'],
  data() {
    return {
      limit: 25,
      offset: 0,
      timestamp: moment().format('x'),
      headers: [
        {
          value: 'name',
          text: 'ชื่อ-นามสกุล',
          sortable: false
        },
        {
          value: 'product_name',
          text: 'ชื่อของรางวัล',
          sortable: false
        },
        {
          value: 'announcement_message',
          text: 'ข้อความที่ส่งไป',
          sortable: false
        },
        {
          value: 'timestamp',
          text: 'วันที่แจ้งผล',
          sortable: false
        }
      ],
      page: 1,
      loading: true,
      data: [],
      pagination: {
        rowsPerPage: -1
      }
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    selectedCampaign() {
      return this.$store.state.selectToaCampaign
    }
  },
  watch: {
    async pagination() {
      this.loading = true
      let { data, total } = await this.getAnnounceLuckydrawHistory(this.limit, 0)
      this.total = total
      this.data = data
      this.page = 1
      this.timestamp = moment().format('x')
      this.loading = false
    }
  },
  methods: {
    async getAnnounceLuckydrawHistory(limit, offset) {
      let data = {
        pageid: this.selectedBot.pageid,
        campaignid: this.selectedCampaign ? this.selectedCampaign.id : null,
        limit: limit,
        offset: offset
      }
      let response = await api.getAnnounceLuckydrawHistory(data)

      return {
        total: response ? response.total : 0,
        data: response ? response.data : []
      }
    },
    async onChange(val) {
      this.loading = true
      let { data, total } = await this.getAnnounceLuckydrawHistory(val.limit, val.offset)
      this.total = total
      this.data = data
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/AnnounceLuckyHistory.vue